const imageModules = import.meta.glob('./*.jpg', { eager: true, import: 'default' }) as Record<string, string>;

const allImages = Object.entries(imageModules)
  .map(([path, src]) => ({ path, src: src as string }))
  .sort((a, b) => a.path.localeCompare(b.path));

export const tocnaImages: string[] = allImages.map(i => i.src);
